import { render, staticRenderFns } from "./Contraproposta.vue?vue&type=template&id=654b48dc&"
import script from "./Contraproposta.vue?vue&type=script&lang=js&"
export * from "./Contraproposta.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports